(function ($, Promise) {

		var FEEDBACK_CORRECT_ANSWER = 2;
		var FEEDBACK_INCORRECT_ANSWER = 3;
		var FEEDBACK_GAMEOVER = 4;
		var FEEDBACK_COMPLETED = 5;

		// Setup the prototype inheritance
		extend(BaseGameLYVLC, PhoneticAlphabet);

		// Constructor
		function PhoneticAlphabet() {

			// Super constructor
			BaseGameLYVLC.call(this, "data/phonetic-alphabet.json");
			this.screensaverDelay = 20;

			this.playlist = new AudioPlaylist();
			this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

			this.lastAcceptedInputValue = false;
			this.currentWord = false;
			this.currentLevel = -1;
			this.currentLetterId = false;
			this.currentOptionsGroup = 0;
			this.triesCount = 0;
			this.currentlySelectedSliderLetter = false;

			this.currentFeedback = false;
			this.feedbackEnabled = false;

			this.instructionsSwiper = false;

			this.redirectTimeout = false;

			this.$letterModel = false;
		}

		// To be overriden in child games
		PhoneticAlphabet.prototype.buildContent = function () {
			return new Promise($.proxy(function (resolve, reject) {

				// Create instructions slides
				this.instructionsSwiper = new Swiper('#instructions', {
					speed: 400,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
					},
				});

				// Handle instructions videos play/pause
				this.instructionsSwiper.on("slideChangeTransitionStart", $.proxy(function () {
					this.stopInstructionVideos();
				}, this));
				this.instructionsSwiper.on("touchStart", $.proxy(function () {
					this.stopInstructionVideos();
				}, this));
				this.instructionsSwiper.on("transitionEnd", $.proxy(function () {
					this.startInstructionVideo(this.instructionsSwiper.activeIndex);
				}, this));

				// Add slider to Ardunio simulator slider
				var lastSent = -1;
				$('.arduino-simulator input[type="range"]').rangeslider({
					polyfill: false,
					rangeClass: 'rangeslider',
					disabledClass: 'rangeslider--disabled',
					horizontalClass: 'rangeslider--horizontal',
					verticalClass: 'rangeslider--vertical',
					fillClass: 'rangeslider__fill',
					handleClass: 'handle',
					onSlide: $.proxy(function (position, value) {
						var normValue = (value / 100);
						var simulatedValue = constrain(Math.floor(normValue * 26), 0, 25);
						if (simulatedValue != lastSent) {
							this.simulateMessage("SLIDE_" + simulatedValue);
							lastSent = simulatedValue
						}
					}, this),
					onSlideEnd: function (position, value) {
					}
				});

				// Save and remove models
				this.$letterModel = $("#screen-3 .letter.model").remove().removeClass("model");

				// Preload audio
				var allAudioFiles = this.findAllAudioFiles(this.data);
				this.audio.preload(allAudioFiles)

				resolve();

			}, this));
		}

		// To be overriden in child games
		PhoneticAlphabet.prototype.initGame = function () {
			console.log("init game");

			// Go to first screen
			if (inElectron()) {
				this.initScreenSaver();
				this.goToScreen(1);
			} else {
				$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
				this.goToScreen("first-click-interact");
			}

			// this.goToScreen(2);
			// this.goToScreen(3);

			// this.validateWord();

			// this.i18n.set("fr");

			// var letters = new String('takeofx').split('');
			// for (var i = 0; i < letters.length; i++) {
			// 	app.currentlySelectedSliderLetter = letters[i];
			// 	app.setLetter(app.currentlySelectedSliderLetter);
			// 	app.selectNextLetter();
			// }
			// setTimeout($.proxy(function () {
			// 	this.validateWord();
			// }, this), 1000);

		};

		// To be overriden in child games
		PhoneticAlphabet.prototype.initScreen = function (screenId) {

			// Super constructor
			if (BaseGameLYVLC.prototype.initScreen.call(this, screenId) == false) {
				return false;
			}

			switch (screenId) {
				case 1:
					this.reset();
					break;
				case 2:
					this.instructionsSwiper.slideTo(0, 0);
					this.startInstructionVideo(0);
					break;
				case 3:
					this.stopAllInstructionVideos();
					this.startLevel(0, true);
					break;
			}

			this.initScreenAudio(screenId);
		}

		// To be overriden in child games
		PhoneticAlphabet.prototype.initScreenAudio = function (screenId) {

			switch (screenId) {
				case 1:
					this.playlist.clear();
					// this.playlist.add(this.data.content.initial_screen.audio_repeat, true, 2000);
					this.playlist.add(this.data.content.initial_screen.audio[this.i18n.lang], false);
					this.playlist.add(this.data.content.initial_screen.audio_repeat[this.i18n.lang], true, 5000);
					this.playlist.play();
					break;
				case 2:
					// Instructions
					var instructionIndex = this.instructionsSwiper.activeIndex + 1;
					this.playlist.clear();
					if (this.data.content["instruction" + instructionIndex].audio) {
						this.playlist.add(this.data.content["instruction" + instructionIndex].audio[this.i18n.lang]);
					}
					if (this.data.content["instruction" + instructionIndex].audio_repeat) {
						this.playlist.add(this.data.content["instruction" + instructionIndex].audio_repeat[this.i18n.lang], true, 5000);
					}
					this.playlist.play();
					break;
				case 3:
					this.playlist.clear();
					this.selectLetter(this.currentLetterId);
					break;
			}
		}

		// To be overriden in child games
		PhoneticAlphabet.prototype.onMessage = function (e) {
			var message = e.message;
			console.log("message received : ", message);

			// Reset still there interval
			if (!message.startsWith("SLIDE_")) {
				this.resetTimer();
			}

			if (this.lockScreen) {
				return;
			}

			if (!message.startsWith("SLIDE_")) {
				if (this.stillThereTimeout != false) {
					this.closeStillThereModal();
					this.initScreenAudio(this.currentScreen);
					return;
				}
			}

			// Global buttons
			switch (this.currentScreen) {
				case 1:
					if (message == this.buttons["english"]) {
						// English button
						this.playlist.clear();
						this.requestedLanguage = "en";
						this.goToScreen(2);
					} else if (message == this.buttons["french"]) {
						// French button
						this.playlist.clear();
						this.requestedLanguage = "fr";
						this.goToScreen(2);
					} else if (message == this.buttons["home"]) {
						// Home button
					}
					break;
				case 3:
					if (message == this.buttons["english"]) {
						// English button
						this.playlist.clear();
						this.i18n.set("en");
						this.currentLevel = this.currentLevel - 1;
						this.goToScreen(2);
					} else if (message == this.buttons["french"]) {
						// French button
						this.playlist.clear();
						this.i18n.set("fr");
						this.currentLevel = this.currentLevel - 1;
						this.goToScreen(2);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
				default:
					if (message == this.buttons["english"]) {
						// English button
						this.i18n.setWithFlip("en");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["french"]) {
						// French button
						this.i18n.setWithFlip("fr");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
			}


			// Slider, always
			if (message.startsWith("SLIDE_")) {
				var inputValue = parseInt(message.replace("SLIDE_", ""));
				if (Math.abs(this.lastAcceptedInputValue - inputValue) > this.settings.phonetic_alphabet.sensitivity_threshold) {
					var mappedLetterIndex = parseInt(map(inputValue, this.settings.phonetic_alphabet.slider_input_min, this.settings.phonetic_alphabet.slider_input_max, 0, 25));
					var letter = this.alphabet[mappedLetterIndex];
					this.currentlySelectedSliderLetter = letter;
					this.lastAcceptedInputValue = inputValue;
					this.resetTimer();
				} else {
					// Stop here execution, since Arduino might be spamming the shit.
					return;
				}
			}

			// Left, right and select butttons
			switch (this.currentScreen) {
				case 1:
					break;
				case 2:
					if (message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT OR NEXT
						if (this.instructionsSwiper.activeIndex >= (this.instructionsSwiper.slides.length - 1)) {
							this.playlist.clear();
							this.goToScreen(3);
						} else {
							this.instructionsSwiper.slideNext();
							this.initScreenAudio(2);
						}
					} else if (message == this.buttons["left"]) {
						// LEFT
						this.instructionsSwiper.slidePrev();
						this.initScreenAudio(2);
					}
					break;
				case 3:
					var isLocked = $("#screen-3 #word-wrapper").hasClass("lock");

					if (!isLocked && message == this.buttons["left"]) {
						// Previous button
						this.selectPreviousLetter();

					} else if (message == this.buttons["select"] || message == this.buttons["right"]) {

						// ENTER / RIGHT button
						if (!isLocked) {

							if ($("#screen-3 #word-wrapper .letter.selected").hasClass("empty") || $("#screen-3 #word-wrapper .letter.selected").hasClass("error")) {
								this.setLetter(this.currentlySelectedSliderLetter);
							}

							if (this.selectNextLetter() === false) {
								this.validateWord();
							}

						} else if (this.currentFeedback == FEEDBACK_CORRECT_ANSWER) {
							// NEXT : when FEEDBACK_CORRECT_ANSWER is on
							this.closeFeedback();
							this.startLevel(this.currentLevel + 1, true);

						} else if (this.currentFeedback == FEEDBACK_COMPLETED || this.currentFeedback == FEEDBACK_GAMEOVER) {
							// NEXT : when FEEDBACK_COMPLETED or  is on
							this.closeFeedback();
							this.goToScreen(1);

						} else if (this.currentFeedback == FEEDBACK_INCORRECT_ANSWER) {
							// NEXT : when FEEDBACK_INCORRECT_ANSWER is on
							this.closeFeedback();
							this.highlightErrors();
							this.selectLetter(0);
							if ($("#screen-3 #word-wrapper .letter").eq(0).hasClass("validated")) {
								this.selectNextLetter()
							}
						}

					} else if (!isLocked && message.startsWith("SLIDE_")) {
						// Slider
						this.setLetter(this.currentlySelectedSliderLetter);
					}

					break;
			}
		}

		PhoneticAlphabet.prototype.startLevel = function (levelId, resetTriesCount) {
			if (resetTriesCount) {
				this.triesCount = 0;
			}
			this.currentLevel = parseInt(levelId);
			this.currentOption = this.data.games[this.currentLevel].options[this.currentOptionsGroup];
			this.startWordFinding(this.currentOption[this.i18n.lang], this.currentOption.size);
			this.selectLetter(0);

			this.updateTopBar();

			// Fill first letter with current slider value
			if (this.currentlySelectedSliderLetter !== false) {
				this.setLetter(this.currentlySelectedSliderLetter);
			}
		}

		PhoneticAlphabet.prototype.startWordFinding = function (word, sizeVariant) {
			this.currentWord = word;
			this.currentLetterId = 0;

			$("#screen-3 #word-wrapper .letter").remove();

			$(word.split('')).each($.proxy(function (i, letter) {
				var $letter = this.$letterModel.clone();
				$letter.data("index", i);
				$letter.data("answer", letter);
				$letter.find(".text").html("&nbsp;")

				if (letter == " ") {
					$letter.addClass("whitespace");
					$letter.removeClass("empty");
				} else if (letter == "\n") {
					$letter.addClass("whitespace break");
					$letter.removeClass("empty");
				}

				$letter.addClass("size-" + sizeVariant);

				// TODO Remove this, as it fills the right answer
				// $letter.removeClass("empty").find(".text").html(letter)

				$("#screen-3 #word-wrapper").append($letter);

			}, this));

			$("#screen-3 #word-wrapper .letter").last().addClass("last");
		}

		PhoneticAlphabet.prototype.selectLetter = function (index) {
			this.currentLetterId = index;
			$("#screen-3 #word-wrapper .letter").removeClass("selected");
			$("#screen-3 #word-wrapper .letter").eq(index).addClass("selected");
			var answer = $("#screen-3 #word-wrapper .letter").eq(index).data("answer");

			// Handle playback
			if (this.data.alphabet[answer]) {
				this.playlist.clear();
				this.playlist.add(this.data.alphabet[answer][this.i18n.lang], true, 2500);
				this.playlist.play();
			}
		}

		PhoneticAlphabet.prototype.selectNextLetter = function () {
			var currentIndex = $("#screen-3 #word-wrapper .letter.selected").data("index");
			var nextIndex = constrain(currentIndex + 1, 0, this.currentWord.length - 1);

			// Prevent going to next letter if current is empty
			if ($("#screen-3 #word-wrapper .letter.selected").hasClass("empty")) {
				return;
			}

			for (var i = (currentIndex + 1); i < this.currentWord.length; i++) {

				// Handle whitespace
				if ($("#screen-3 #word-wrapper .letter").eq(i).hasClass("whitespace")) {
					continue;
				}

				// Handle validated letters
				if ($("#screen-3 #word-wrapper .letter").eq(i).hasClass("validated")) {
					continue;
				}

				this.selectLetter(i);
				return;
			}

			return false;
		}

		PhoneticAlphabet.prototype.selectPreviousLetter = function () {
			var currentIndex = $("#screen-3 #word-wrapper .letter.selected").data("index");

			for (var i = (currentIndex - 1); i >= 0; i--) {

				// Handle whitespace
				if ($("#screen-3 #word-wrapper .letter").eq(i).hasClass("whitespace")) {
					continue;
				}

				// Handle validated letters
				if ($("#screen-3 #word-wrapper .letter").eq(i).hasClass("validated")) {
					continue;
				}

				this.selectLetter(i);
				return;
			}
		}

		PhoneticAlphabet.prototype.setLetter = function (letter) {
			if (letter != false) {
				$("#screen-3 #word-wrapper .letter.selected").find(".text").text(letter)
				$("#screen-3 #word-wrapper .letter.selected").removeClass("empty error validated");
			}
		}

		PhoneticAlphabet.prototype.validateWord = function () {
			var errorFound = false;
			var answer = this.currentWord.split('');

			// Validate each letter
			for (var i = 0; i < answer.length; i++) {

				if (answer[i].charAt(0) == 160 || answer[i].charAt(0) == 32) {
					// This is a whitespace, accept space and non-breakable spaces
					continue;

				} else if ($("#screen-3 #word-wrapper .letter").eq(i).find(".text").text().trim() != answer[i].trim()) {
					// This is not the correct letter
					errorFound = true;
					console.log("error found at letter " + i + ", found char '" + $("#screen-3 #word-wrapper .letter").eq(i).find(".text").text().charCodeAt(0) + "' instead of '" + answer[i].charCodeAt(0) + "'")
				}
			}

			// Redirect to correct feedback
			if (errorFound && this.triesCount < 1) {
				console.log("try again")
				this.triesCount++;
				this.showFeedback(FEEDBACK_INCORRECT_ANSWER);
				this.shakeScreen();

			} else if (errorFound) {
				console.log("gameover")
				this.showFeedback(FEEDBACK_GAMEOVER);
				this.shakeScreen();

				// Onscreen for 10 seconds, then return to start screen
				this.redirectTimeout = setTimeout($.proxy(function () {
					this.goToScreen(1);
				}, this), 14000);

			} else {
				console.log("good answer")
				$("#screen-3 #word-wrapper").addClass("lock");

				// Read current word
				this.playlist.clear();
				var fullword_audio = this.data.games[this.currentLevel].options[this.currentOptionsGroup].audio[this.i18n.lang];
				this.playlist.add(fullword_audio, false, false, $.proxy(function () {
					// Go to final screen
					if ((this.currentLevel) >= (this.data.games.length - 1)) {
						this.showFeedback(FEEDBACK_COMPLETED);

						// Onscreen for 10 seconds, then return to start screen
						this.redirectTimeout = setTimeout($.proxy(function () {
							this.goToScreen(1);
						}, this), 14000);

					} else {
						this.showFeedback(FEEDBACK_CORRECT_ANSWER);
					}

				}, this));
				this.playlist.play();
			}

			this.updateTopBar();
		}

		PhoneticAlphabet.prototype.showFeedback = function (feedback) {

			if (this.currentFeedback != false) {
				return;
			}

			this.feedbackEnabled = true;
			this.currentFeedback = feedback;
			var feedbackId = "";

			this.playlist.clear();

			if (feedback == FEEDBACK_INCORRECT_ANSWER) {
				$("#game-feedback .feedback").removeClass("current");
				$("#game-feedback #game-feedback-incorrect").addClass("current");
				feedbackId = "incorrect";

				this.playlist.add(this.data.content.incorrect_answer.audio[this.i18n.lang]);
				this.playlist.add(this.data.content.incorrect_answer.audio_repeat[this.i18n.lang]);

			} else if (feedback == FEEDBACK_GAMEOVER) {
				$("#game-feedback .feedback").removeClass("current");
				$("#game-feedback #game-feedback-gameover").addClass("current");
				feedbackId = "gameover";

				this.playlist.add(this.data.content.gameover.audio[this.i18n.lang]);

			} else if (feedback == FEEDBACK_COMPLETED) {
				this.currentFeedback = FEEDBACK_COMPLETED;
				$("#game-feedback .feedback").removeClass("current");
				$("#game-feedback #game-feedback-completed").addClass("current");
				feedbackId = "completed"

				this.playlist.add(this.data.content.completed.audio[this.i18n.lang]);

			} else if (feedback == FEEDBACK_CORRECT_ANSWER) {
				this.currentFeedback = FEEDBACK_CORRECT_ANSWER;

				var answerVariant = this.currentLevel % this.data.content.correct_answer.length;
				$("#game-feedback #game-feedback-correct .description").hide();
				$("#game-feedback #game-feedback-correct #feedback-correct-variant-" + (answerVariant + 1)).show();

				$("#game-feedback .feedback").removeClass("current");
				$("#game-feedback #game-feedback-correct").addClass("current");
				feedbackId = "correct";

				this.playlist.add(this.data.content.correct_answer[answerVariant].audio[this.i18n.lang]);
				this.playlist.add(this.data.content.correct_answer[answerVariant].audio_repeat[this.i18n.lang], true, 5000);
			}

			this.playlist.play();

			$("#game-feedback").addClass("active");
			$("#screen-3 #word-wrapper").addClass("lock");

			// Animate in
			var tl = new TimelineMax();
			tl.fromTo("#game-feedback-overlay", 0.3, {
				autoAlpha: 0,
				ease: Sine.easeInOut
			}, {
				autoAlpha: 1,
				ease: Sine.easeInOut
			});
			tl.fromTo("#game-feedback-" + feedbackId, 0.3, {
				autoAlpha: 0,
				y: 100,
				ease: Sine.easeInOut
			}, {
				autoAlpha: 1,
				y: 0,
				ease: Sine.easeInOut
			});

		}

		PhoneticAlphabet.prototype.shakeScreen = function () {

			// Animate in
			var tl = new TimelineMax();
			tl.fromTo(["#word-wrapper", "#game-perso"], 0.1, {
				x: 0,
				ease: Sine.easeInOut
			}, {
				x: 10,
				ease: Sine.easeInOut
			});
			tl.to(["#word-wrapper", "#game-perso"], 0.2, {
				x: -10,
			});
			tl.to(["#word-wrapper", "#game-perso"], 0.2, {
				x: 10,
			});
			tl.to(["#word-wrapper", "#game-perso"], 0.2, {
				x: -10,
			});
			tl.to(["#word-wrapper", "#game-perso"], 0.2, {
				x: 10,
			});
			tl.to(["#word-wrapper", "#game-perso"], 0.1, {
				x: 0,
			});
		}

		PhoneticAlphabet.prototype.closeFeedback = function () {

			if (this.currentFeedback == false) {
				return;
			}

			this.currentFeedback = false;

			$("#screen-3 #word-wrapper").removeClass("lock");

			var tl = new TimelineMax();
			tl.to(".popup", 0.3, {
				autoAlpha: 0,
				y: 100,
				ease: Sine.easeInOut
			});
			tl.to("#game-feedback-overlay", 0.3, {
				autoAlpha: 0,
				ease: Sine.easeInOut
			});
			tl.addCallback(function () {
				this.feedbackEnabled = false;
				$("#game-feedback").removeClass("active");
			}, "+=0.0", [], this);
		}

		PhoneticAlphabet.prototype.highlightErrors = function () {

			// Validate each letter
			var answer = this.currentWord.split('');
			for (var i = 0; i < answer.length; i++) {

				if ($("#screen-3 #word-wrapper .letter").eq(i).hasClass("whitespace")) {
					continue;
				}

				if ($("#screen-3 #word-wrapper .letter").eq(i).find(".text").text() != answer[i]) {
					$("#screen-3 #word-wrapper .letter").eq(i).addClass("error");
				} else {
					$("#screen-3 #word-wrapper .letter").eq(i).addClass("validated");
				}
			}
		}

		PhoneticAlphabet.prototype.updateTopBar = function () {
			$("#game-top-bar .current-level").text(this.currentLevel + 1);
			$("#game-top-bar .current-try").html(this.triesCount + 1);
		}

		PhoneticAlphabet.prototype.startInstructionVideo = function (slideIndex) {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					if (i == slideIndex) {
						n2.play();
					} else {
						n2.currentTime = 0;
						n2.pause();
					}
				});
			});
		}

		PhoneticAlphabet.prototype.stopInstructionVideos = function () {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					n2.pause();
				});
			});
		}

		PhoneticAlphabet.prototype.stopAllInstructionVideos = function () {
			var videos = $(this.instructionsSwiper.el).find("video");
			videos.each(function (i, n) {
				n.pause();
			});
		}

		PhoneticAlphabet.prototype.goToScreenSaver = function () {

			// Super constructor
			if (BaseGameLYVLC.prototype.goToScreenSaver.call(this) == false) {
				return false;
			}
		}

		PhoneticAlphabet.prototype.reset = function (screenId) {

			// Super
			if (BaseGameLYVLC.prototype.reset.call(this, screenId) == false) {
				return false;
			}

			if (this.redirectTimeout != false) {
				clearTimeout(this.redirectTimeout);
				this.redirectTimeout = false;
			}

			this.closeFeedback();

			// Reset instruction slider
			this.instructionsSwiper.slideTo(0, 0);
			this.stopAllInstructionVideos();

			$("#screen-3 #word-wrapper .letter").remove();
			$("#screen-3 #word-wrapper").removeClass("lock");

			this.currentWord = false;
			this.currentLevel = -1;
			this.currentLetterId = false;
			this.currentOptionsGroup = (this.currentOptionsGroup + 1) % app.data.games[0].options.length;
			this.triesCount = 0;
			this.currentFeedback = false;
		}

		// Expose PhoneticAlphabet
		window.PhoneticAlphabet = PhoneticAlphabet;
	}
)
(jQuery, Promise);
